import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

const namespace = 'widgets';
export const keyPrefix = 'card_faces_viewer';
export const useCardFacesViewerTranslation = (): UseTranslationResponse<typeof namespace, typeof keyPrefix> => {
  return useTranslation(namespace, { keyPrefix });
};

export const ruRu = ({
  [keyPrefix]: {
    no_faces: 'Нет данных. Добавьте лица.',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    no_faces: 'No data. Add faces.',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    no_faces: 'No hay datos. Añadir caras.',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    no_faces: 'Sem dados. Adicione faces.',
  },
}) as Record<string, unknown>;
